import { ScheduleTime } from '@src/core/buyerApiClient';
import { RescheduleStep } from '@src/domains/sale-items';

export const RescheduleActionType = {
  SelectDate: 'RESCHEDULE/SELECT_DATE',
  SelectTime: 'RESCHEDULE/SELECT_TIME',
  ResetFields: 'RESCHEDULE/RESET_FIELDS',
  SetCurrentStep: 'RESCHEDULE/SET_CURRENT_STEP',
} as const;

type ActionProps =
  | {
      type: typeof RescheduleActionType.SelectDate;
      payload: string;
    }
  | {
      type: typeof RescheduleActionType.SelectTime;
      payload: ScheduleTime;
    }
  | {
      type: typeof RescheduleActionType.ResetFields;
    }
  | {
      type: typeof RescheduleActionType.SetCurrentStep;
      payload?: RescheduleStep;
    };

type StateProps = {
  date?: string;
  visible: boolean;
  time?: ScheduleTime;
  currentStep: RescheduleStep | undefined;
  steps: RescheduleStep[];
};

export const initialState: StateProps = {
  date: undefined,
  time: undefined,
  currentStep: RescheduleStep.Date,
  steps: [RescheduleStep.Date, RescheduleStep.Time, RescheduleStep.Summary],
  visible: true,
};

function reducer(state: StateProps, action: ActionProps) {
  const newState = { ...state };

  switch (action.type) {
    case RescheduleActionType.SelectDate: {
      newState.date = action.payload;

      return newState;
    }

    case RescheduleActionType.SelectTime: {
      newState.time = action.payload;

      return newState;
    }

    case RescheduleActionType.ResetFields: {
      return { ...initialState, visible: false };
    }

    case RescheduleActionType.SetCurrentStep: {
      newState.currentStep = action.payload;

      return newState;
    }
    default:
      return state;
  }
}

export default reducer;
